import { NgClass } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SvgIconComponent } from '@shared/elements/svg-icon/svg-icon.component';
import { UserPrimaryInfo } from '@shared/models/model';
import { LocalStorageService } from '../../services/local-storage.service';
import { MODULE_LIST } from './module-list';

@Component({
  selector: 'side-bar',
  standalone: true,
  imports: [NgClass, SvgIconComponent],
  templateUrl: './side-bar.component.html',
})
export class SideBarComponent {
  private readonly storage = inject(LocalStorageService);
  private readonly router = inject(Router);

  modules = MODULE_LIST;
  allowedModules: any[] = [];
  activeModule = 'Home';
  hideFullMenu = false;
  hoveredModule?: string = '';
  originalState = false;
  isChildActive = false;
  parentRoute = '';
  userInfo?: UserPrimaryInfo | null;

  constructor() {
    effect(() => {
      this.hideFullMenu = this.storage.isMenuCollapsed();
      this.activeModule = this.storage.currentModule();
      this.userInfo = this.storage.userInfo();

      (this.userInfo?.userPermission ?? [])?.forEach((i) => {
        if (i.permission === 'FULL_ACCESS' || i.permission === 'READ_ONLY') {
          this.allowedModules.push(i.module);
        }
      });

      if (this.userInfo?.userRole?.name !== 'SUPER_ADMIN') {
        this.modules = MODULE_LIST.filter((i) => this.allowedModules.findIndex((el) => i.module === el) > -1);
      }
    });
  }

  navigateToModule(title: string, route: string, child?: { title: string; name: string }): void {
    if (child) {
      this.originalState = this.hideFullMenu = false;
      this.isChildActive = true;
      this.activeModule = child.title;
      this.storage.changeCurrentModule(child.title);
      this.parentRoute = route;
      this.router.navigate([`/admin/${route}/${child.name}`]);
    } else {
      this.activeModule = title;
      this.storage.changeCurrentModule(title);
      if (title !== 'Settings') {
        this.parentRoute = '';
        this.router.navigate([`/admin/${route}`]);
      } else {
        this.storage.toggleMenu(false);
        this.originalState = this.hideFullMenu = false;
        this.parentRoute = route;
        this.router.navigate([`/admin/${route}/user-labels`]);
      }
    }
  }

  showChildrenOnHover(title: string): void {
    this.originalState = this.hideFullMenu;

    if (title === 'Settings') {
      this.hoveredModule = title;
      this.hideFullMenu = false;
    }
  }
}
